import { ReactNode } from 'react';
import { Box } from '@mui/material';

type NonDefaultStateIndicatorPropsT = {
  children: ReactNode;
  show: boolean;
};

function NonDefaultStateIndicator({ children, show }: NonDefaultStateIndicatorPropsT) {
  return (
    <Box component="span" sx={{ position: 'relative', display: 'inline-block' }}>
      {children}
      {show ? (
        <Box
          component="span"
          aria-hidden
          sx={{
            position: 'absolute',
            top: '1px',
            left: 'calc(100% + 4px)',
            width: '6px',
            height: '6px',
            borderRadius: '50%',
            backgroundColor: 'error.main',
          }}
        />
      ) : null}
    </Box>
  );
}

export default NonDefaultStateIndicator;
